import { useAdobeSatellite, dataLayer } from './adobeAnalytics.conf'
import dayjs from 'dayjs'

export const AdobeEventManager = {
  emit: (event: string, trackingEvent: string) => {
    dataLayer.event = {
      eventInfo: { eventName: event },
    }
    AdobeEventManager.track(trackingEvent)
  },
  track: (trackingEvent: string) => {
    useAdobeSatellite(adobeSatellite => {
      dataLayer.user.profile.interactionInfo = {
        hour: `${dayjs().hour()}:${dayjs().minute()}`,
        day: `${dayjs().year()}.${dayjs().month() + 1}.${dayjs().date()}`,
        dayType: `${dayjs().day()}`,
        timestamp: dayjs().valueOf(),
      }
      adobeSatellite.track(trackingEvent)
    });
  },
}